export interface SponsorshipTier {
  name: string;
  subtitle: string;
  description: string;
  price: string;
  period: string;
  seats: number;
  features: string[];
  cta: string;
  ctaUrl?: string;
}

export interface AddOn {
  id: string;
  name: string;
  description: string;
  price: string;
  details: string;
  highlight?: string;
  features?: string[];
}

export interface ValueStory {
  title: string;
  description: string;
}

export const sponsorshipTiers: SponsorshipTier[] = [
  {
    name: "Solo",
    subtitle: "Advisor Platform License",
    description: "Up to 5 Households",
    price: "$2,000",
    period: "/ Year",
    seats: 5,
    features: [
      "5 Essential household licenses",
      "Advisor dashboard access",
      "Client engagement tracking",
      "Quarterly impact summary",
      "Co-branded onboarding materials",
      "Priority advisor support"
    ],
    cta: "Start Partnership",
    ctaUrl: "https://app.seniorthrive.com/sponsor/signup?plan=solo"
  },
  {
    name: "Core",
    subtitle: "Advisor Platform License",
    description: "Up to 10 Households",
    price: "$3,750",
    period: "/ Year",
    seats: 10,
    features: [
      "10 Essential household licenses",
      "Everything in Solo",
      "Portfolio-level client view",
      "Client safety status summaries",
      "Advisor marketing toolkit"
    ],
    cta: "Start Partnership",
    ctaUrl: "https://app.seniorthrive.com/sponsor/signup?plan=core"
  },
  {
    name: "Growth",
    subtitle: "Advisor Platform License",
    description: "Up to 20 Households",
    price: "$7,000",
    period: "/ Year",
    seats: 20,
    features: [
      "20 Essential household licenses",
      "Everything in Core",
      "Advanced engagement analytics",
      "Annual strategy review"
    ],
    cta: "Start Partnership",
    ctaUrl: "https://app.seniorthrive.com/sponsor/signup?plan=growth"
  },
  {
    name: "Scale",
    subtitle: "Advisor Platform License",
    description: "Up to 50 Households",
    price: "$16,000",
    period: "/ Year",
    seats: 50,
    features: [
      "50 Essential household licenses",
      "Everything in Growth",
      "Dedicated partner success lead",
      "Aggregated reporting exports",
      "Co-marketing collaboration"
    ],
    cta: "Contact Sales"
  }
];

export const addOns: AddOn[] = [
  {
    id: "thrivefamily-upgrade",
    name: "Family Upgrade",
    description: "Every platform license includes Essential, the older adult plus one family member (2 people). Add the Family plan to expand that to the older adult plus up to four family members (5 people total). Adult children, spouses, and caregivers all get a shared dashboard, coordinated updates, and tools to stay aligned on what matters most. When the whole family is connected through your sponsorship, you become the advisor the entire household trusts, not just one person.",
    price: "+$225/seat/year",
    details: "Upgrade any household from Essential (older adult + 1 family member) to Family (older adult + up to 4 family members)",
    highlight: "Deepen multi-generational relationships",
    features: [
      "Shared family dashboard with real-time updates",
      "Coordinated communication across adult children and caregivers",
      "Each family member gets their own login and personalized view",
      "You stay visible as the advisor who brought the family together"
    ]
  },
  {
    id: "concierge-onboarding",
    name: "Concierge Onboarding",
    description: "Make every first impression count. Our team personally walks each household through account setup, device connections, and platform orientation on a one-on-one call. Your clients start confident and engaged from day one, and your name is attached to the experience.",
    price: "$50/household",
    details: "Personalized kick-off call for each household so they hit the ground running"
  }
];

export const valueStories: ValueStory[] = [
  {
    title: "Meaningful Differentiation",
    description: "Stand for more than transactions. Offer structured support that helps older adults live safely and independently at home."
  },
  {
    title: "Stronger Relationships",
    description: "Stay relevant during major life transitions. Be present when conversations shift from planning to real-world aging decisions."
  },
  {
    title: "Low Operational Lift",
    description: "Simple sponsorship model. No complex implementation. Households activate directly inside SeniorThrive."
  },
  {
    title: "Clear Value to the People You Serve",
    description: "Support safety, communication, and coordination in one place, something families will actually use."
  }
];
